import React, { memo, useMemo } from "react";
import { GoogleMap, MarkerF, CircleF } from "@react-google-maps/api";
import { useSelector } from "react-redux";
import WithGoogleMapsLoader from "./WithGoogleMapsLoader";

const MapComponentBeta = ({ enRoute }) => {
  const driverLocation = useSelector((state) => state.location.driverLocation);

  const liveLocationIcon = {
    path: window.google.maps.SymbolPath.CIRCLE,
    fillColor: "#91B156",
    fillOpacity: 2,
    scale: 8,
    strokeColor: "#192B0C",
    strokeWeight: 3,
    // Custom CSS animation class
    className: "pulsating-dot",
  };
  const circleOptions = {
    strokeColor: "#007bff",
    strokeOpacity: 0.8,
    strokeWeight: 2,
    fillColor: "#007bff",
    fillOpacity: 0.35,
    clickable: false,
    draggable: false,
    editable: false,
    visible: true,
    radius: 8, // Radius in meters
    zIndex: 1,
  };

  const driverPosition = useMemo(() => driverLocation, [driverLocation]);
  return (
    <div className='Map'>
      <GoogleMap
        mapContainerClassName='h-full w-full'
        center={enRoute || driverPosition}
        zoom={enRoute ? 18 : 15}
      >
        <MarkerF
          position={enRoute || driverPosition}
          icon={enRoute && liveLocationIcon}
        />
      </GoogleMap>
    </div>
  );
};

export default WithGoogleMapsLoader(memo(MapComponentBeta));
